// 尺寸454*320
import React from 'react'
import { Card } from 'antd'
import ReprintPage from '@/pages/AndroidDevice/reprint/print'

const ReprintWebPage = () => {
  return (
    <div className="displayFlex alignCenter justifyContentCenter">
      <div className="mt20">
        <Card
          style={{
            width: 550
          }}
          className="nfc_card"
        >
          <ReprintPage reprintType="web"></ReprintPage>
        </Card>
      </div>
    </div>
  )
}
export default ReprintWebPage
